import { ArabicEach, findRecursive } from '@/mm/utils.js'

export function washData(walkedNode) {
  let ArabicRule = [
    {
      flag: 'home-product-title-index',
      dataType: ['design', 'design', 'design'],
      onlyEnglish: ['title_textAlign', false, false],
      englishTitleLeft: ['left', 'self_marginLeft', 'self_paddingLeft'],
      englishTitleRight: ['right', 'self_marginRight', 'self_paddingRight']
    },
    {
      flag: 'home-product-title-total',
      dataType: ['design'],
      onlyEnglish: ['title_textAlign'],
      englishTitleLeft: ['left'],
      englishTitleRight: ['right']
    },
    {
      flag: 'home-product-title',
      dataType: ['design'],
      onlyEnglish: ['title_textAlign'],
      englishTitleLeft: ['left'],
      englishTitleRight: ['right']
    }
  ]
  ArabicEach(walkedNode, ArabicRule)
}
